const customization = function() {
  let currentLocation;
  currentLocation = window.location.href;
  if (currentLocation.match(/site/)) {
    localStorage.setItem("faktura-skin", getSecondPart(currentLocation))
  }
  let defaultSkin;
  defaultSkin = localStorage.getItem("faktura-skin");
  if (defaultSkin === null) {
    localStorage.setItem("faktura-skin", "0");
  }

  function getSecondPart(str) {
    let secondPart = str.split('?site=')[1];
    return secondPart ? secondPart.split('&')[0] : secondPart;
  }

  let skin;
  skin = defaultSkin
  const localSkin = skin + '.css';
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = 'https://elf.faktura.ru/elf/skins/' + skin + '/favicon.ico';
  document.getElementsByTagName('head')[0].appendChild(link);
  const skinUrl = process.env.PUBLIC_URL + '/skins/' + localSkin;
  document.head.innerHTML += `<link type="text/css" rel="stylesheet" href=${skinUrl}>`;
}

export default customization;
